import React, { useState } from 'react';
import Select, { components } from 'react-select';

const languageOptions = [
    { value: 'de', label: 'Germany | DE', country: 'Germany', flag: 'fi fi-de' },
    { value: 'at', label: 'Austria | AT', country: 'Austria', flag: 'fi fi-at' },
    { value: 'be', label: 'Belgium | BE', country: 'Belgium', flag: 'fi fi-be' },
    // add more languages as needed
];

const Option = (props) => {
    return (
        <components.Option {...props}>
            <span className={props.data.flag} style={{ marginRight: '10px' }} />
            {props.data.label}
        </components.Option>
    );
};

const SingleValue = ({ data }) => (
    <div className="single-value-container" style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        <span className={data.flag} style={{ marginRight: '10px' }} />
        <span className="single-value-text">{data.label}</span>
    </div>
);

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        border: state.isFocused ? 'none' : 'none', // Change border color here
        backgroundColor: '#F5F8F6',
        display: 'flex',
        alignItems: 'center',
        height: '35px',
        minHeight: '35px',
        boxShadow: state.isFocused ? 'none' : 'none', // Remove the shadow
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: 0,
        marginTop: '11px',
        border: 'none',
    }),
    option: (provided) => ({
        ...provided,
        border: 'none',
    }),
    singleValue: (provided) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
    }),
    valueContainer: (provided) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: '100%',
    }),
}

const LanguageSelector = () => {
    const [selectedLanguage, setSelectedLanguage] = useState(languageOptions[0]);

    const handleLanguageChange = (selectedOption) => {
        setSelectedLanguage(selectedOption);
    };

    return (
        <Select
            options={languageOptions}
            styles={customStyles}
            isSearchable={false}
            value={selectedLanguage}
            onChange={handleLanguageChange}
            getOptionLabel={(option) => option.label}
            className="language-dropdown"
            components={{ Option, SingleValue }}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: '#FF1628',
                    primary25: '#EDF1EF',
                    primary50: '#DEE5E4',
                },
            })}
        />
    );
};

export default LanguageSelector;
